"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isCodeLengthValid = function isCodeLengthValid(_ref) {
  var code = _ref.code,
      length = _ref.length;

  if (code) {
    var regex = new RegExp("[0-9]{".concat(length, "}"), 'g');
    return regex.test(code.toString());
  }

  return false;
};

var _default = isCodeLengthValid;
exports["default"] = _default;
//# sourceMappingURL=isCodeLengthValid.js.map